import React, {useCallback, useState} from 'react';
import {Layout} from '../layout';
import {Days} from './Days';
import {Months} from './Months';
import {CalendarProps} from './types';

const DefaultWidth = 340;
const DefaultHeight = 375;

export const Calendar: React.FC<CalendarProps> = ({currentDate, onChange}) => {
  const DaySize = DefaultWidth / 7;

  // State
  const [selectedMonth, setSelectedMonth] = useState<Date>(currentDate);

  // Callbacks
  const handleSelectedDateChanged = useCallback(
    (date: Date) => {
      // Update month to show the selected date's month
      setSelectedMonth(date);
      // Callback
      onChange(date);
    },
    [onChange],
  );

  return (
    <Layout
      width={DefaultWidth}
      height={DefaultHeight}
      backgroundColor={'background_mono_primary'}
      borderRadius={'8'}
      borderStyle="solid"
      borderWidth={'1'}
      borderColor={'border_mono_30'}
      raised
      vertical
      padding={'32'}>
      {/** Month navigation */}
      <Months currentMonth={selectedMonth} onChange={setSelectedMonth} />
      {/** Days navigation */}
      <Days
        size={DaySize}
        currentMonth={selectedMonth}
        currentDate={currentDate}
        onChange={handleSelectedDateChanged}
      />
    </Layout>
  );
};
